/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Submit_Application_NoteInputs */

const en_confirm_submit_application_note = /** @type {(inputs: Confirm_Submit_Application_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note: After submitting the application, you can no longer change your information.`)
};

const de_confirm_submit_application_note = /** @type {(inputs: Confirm_Submit_Application_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinweis: Nach Einreichen der Bewerbung kannst du deine Angaben nicht mehr ändern.`)
};

/**
* | output |
* | --- |
* | "Note: After submitting the application, you can no longer change your information." |
*
* @param {Confirm_Submit_Application_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const confirm_submit_application_note = /** @type {((inputs?: Confirm_Submit_Application_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Submit_Application_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_confirm_submit_application_note(inputs)
	return en_confirm_submit_application_note(inputs)
});